<template>
  <div class="wizard-body small-9 columns">
    <div>
        <h2 class="page-sub-title">{{$t('INBOX_MGMT.ADD.WHATSAPP_PERSONAL.QR_CODE_SCAN.TITLE')}}</h2>
        <p>{{$t('INBOX_MGMT.ADD.WHATSAPP_PERSONAL.QR_CODE_SCAN.DESCRIPTION')}}</p>
    </div>
    <ReConnectWhatsappPersonal
    :inboxName="inboxName"
    :isTwoCol="true"
    @onCreateChannel="createChannel"
    @onChannelConnected="createChannel"
    @onQRSessionTimout="onQRSessionTimout"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import alertMixin from 'shared/mixins/alertMixin';
import { required } from 'vuelidate/lib/validators';
import {WP_PERSONAL_EVENTS} from "./channels/constant";
// import router from '../../../../index';
import router from '../../../../routes/index';
import InboxApi from 'dashboard/api/inboxes.js';
import ReConnectWhatsappPersonal from './ReConnectWhatsappPersonal.vue'


export default {
  components:{
    ReConnectWhatsappPersonal,
  },
  mixins: [alertMixin],
  data() {
    return {
      inboxName:"",
    };
  },
  computed: {
    ...mapGetters({
       currentUser: 'getCurrentUser',
    }),
  },
  mounted() {
    this.inboxName = sessionStorage.getItem("whatsapp_personal_inbox_name");
  },
  methods: {
    async createChannel(inbox) {
      console.log(inbox,"createChannel");
      try {
        // go to add agent step
        this.$router.push(`/app/accounts/${this.currentUser.account_id}/settings/inboxes/new/${inbox.id || inbox.inbox_id}/agents`);
        // router.replace({
        //   name: 'settings_inboxes_add_agents',
        //   params: {
        //     page: 'new',
        //     inbox_id:inbox.id,
        //   },
        // });
      } catch (error) {
        console.log(error,error.message);
        console.log(error.response);
        this.showAlert(error.response?.data?.message || this.$t('INBOX_MGMT.ADD.WHATSAPP.API.ERROR_MESSAGE'));
      }
    },
    onQRSessionTimout(){
      this.$router.push(`/app/accounts/${this.currentUser.account_id}/settings/inboxes/new/whatsapp_personal`);
    },

  },
}
</script>

<style lang="scss" scoped>
@import '~dashboard/assets/scss/widgets/_fonts.scss';

.qr_container{
  width: fit-content;
  text-align: center;

  .counter{
    font-size: 40px;
    color: #6F1DDF;
  }
}
</style>